import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Link } from 'react-router-dom';
import { Navigation } from './Navigation';
import { AMAZON_URL, BOOK_TITLE, BOOK_COVER, BOOK_TAGLINE } from '../lib/bookLinks';
import './Dashboard.css';

export const Dashboard: React.FC = () => {
  const { user } = useAuth();

  const firstName = user?.email
    ? user.email.split('@')[0].replace(/[._]/g, ' ').replace(/\b\w/g, c => c.toUpperCase())
    : '';

  return (
    <div className="dashboard-container">
      <Navigation />

      <div className="status-banner">
        <div className="status-banner-inner">
          <div className="status-banner-item">
            <span className="status-banner-label">Communications</span>
            <span className={user?.emailVerified ? 'status-active' : 'status-inactive'}>
              {user?.emailVerified ? '✓ Verified' : '⚠ Unverified'}
            </span>
          </div>
          <div className="status-banner-divider" />
          <div className="status-banner-item">
            <span className="status-banner-label">Access Level</span>
            <span className="status-active" style={{ textTransform: 'capitalize' }}>
              {user?.effectiveTier || 'free'}
              {user?.hasComplimentaryAccess && ' ✓'}
            </span>
          </div>
        </div>
      </div>

      <div className="dashboard-content">
        <div className="welcome-section">
          <h2>Your Wealth Financial Management System</h2>
          {firstName && <span className="welcome-name">Welcome back, {firstName}</span>}
        </div>

        {!user?.emailVerified && (
          <div className="verification-alert">
            <h3>⚠️ Email Verification Required</h3>
            <p>Please verify your email address to receive system alerts and access all features.</p>
            <Link to="/verify-email" className="btn-verify">
              Verify Email Now
            </Link>
          </div>
        )}

        <div className="quick-start-grid">
          <div className="accent-card accent-gold">
            <img
              src={BOOK_COVER}
              alt={`${BOOK_TITLE} -- book cover`}
              className="book-card-cover"
            />
            <h3>{BOOK_TITLE}</h3>
            <p>{BOOK_TAGLINE}</p>
            <p>
              The book walks you through every pillar -- earning, saving,
              investing, debt, and planning for later -- in the same
              plain-English style as the tools on this site.
            </p>
            <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center', flexWrap: 'wrap', marginTop: 'auto', justifyContent: 'center' }}>
              <Link to="/book" className="btn-primary">
                Read More
              </Link>
              <a
                href={AMAZON_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary"
                style={{ background: '#d5b26e', color: '#1c1c20', fontWeight: 700 }}
              >
                Buy on Amazon
              </a>
            </div>
          </div>

          <div className="accent-card accent-green">
            <h3>Start Here — Net Worth Baseline</h3>
            <p>Most people think about money in fragments — income here, debt there, investments somewhere else. Net worth brings those pieces together into a single, coherent view of where you actually stand.</p>
            <p>The Net Worth Tracker helps you establish a clear financial baseline, track progress over time, and see how earning, saving, investing, and debt interact. Updated monthly or quarterly, it turns long-term thinking into observable progress.</p>
            <p>This is the foundation of everything else in the system. Every other tool — lifecycle planning, capital allocation, monitoring — builds on knowing your starting point.</p>
            <div style={{ marginTop: 'auto', textAlign: 'center' }}>
              <Link to="/net-worth" className="btn-primary">
                Setup Net Worth Baseline
              </Link>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};